import { useWizardStepsStore } from './WizardStepsStore';

/**
 * This function retrieves the wizard steps as a record with step IDs as keys and boolean values indicating their completion status.
 *
 * @returns A record where each key is a wizard step ID and the corresponding value is `false`.
 *
 * @example
 * ```typescript
 * const wizardStepsRecord = getWizardStepAsRecord();
 * console.log(wizardStepsRecord); // Output: { step1: false, step2: false, ... }
 * ```
 */
export function createWizardStepsRecord(): Record<string, boolean> {
	return useWizardStepsStore.getState().wizardSteps.reduce<Record<string, boolean>>((value, wizardStep) => {
		value[wizardStep.id] = false;
		return value;
	}, {});
}
